import { render, staticRenderFns } from "./jumlahKomuni.vue?vue&type=template&id=78987dda&scoped=true&"
import script from "./jumlahKomuni.vue?vue&type=script&lang=js&"
export * from "./jumlahKomuni.vue?vue&type=script&lang=js&"
import style0 from "./jumlahKomuni.vue?vue&type=style&index=0&id=78987dda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78987dda",
  null
  
)

export default component.exports